import React from 'react';
import { Link } from 'react-router-dom';

import Card from 'v3/components/Card';
import { Text } from 'v3/components';
import { validatePermission } from 'actions/index';
import StatusBadge from 'v3/pages/ShippingCompany/Requests/shared/StatusBadge';

import { useShippingCompany } from '../shared/context';

// A main-api só devolve registration_request nos três status finais (RN-014); sem ele, o card não aparece.
export default function RequestStatusCard() {
  const shippingCompany = useShippingCompany();
  const registrationRequest = shippingCompany.data?.registration_request;

  if (shippingCompany.isFetching || !registrationRequest) return null;

  const canViewRequests = validatePermission('VISUALIZAR_TRANSPORTADORAS_SOLICITACOES');

  return (
    <Card
      header={
        <Text color="dark" type="header">
          Solicitação de cadastro
        </Text>
      }
    >
      <div className="d-flex align-items-center flex-wrap mt-2" style={{ gap: '0.75rem' }}>
        <Text type="label" color="dark">
          Status da solicitação:
        </Text>
        <StatusBadge status={registrationRequest.status} />
        {canViewRequests && (
          <Link to={`/transportadoras/solicitacoes/${registrationRequest.id}`}>
            <Text type="regular" color="primary" weight={500}>
              Ver solicitação
            </Text>
          </Link>
        )}
      </div>
    </Card>
  );
}
